export const COMANDE_UNICA_USCITA = 'UU';
export const COMANDE_PRIMA_USCITA = 'U1';
export const COMANDE_SECONDA_USCITA = 'U2';
export const COMANDE_TERZA_USCITA = 'U3';
export const COMANDE_QUARTA_USCITA = 'U4';